import styled from 'styled-components/macro'

import { Table, TextField } from '@loadsmart/loadsmart-ui'

export const TableCellLabelWrapper = styled(Table.Cell)`
  width: 15%;
`

export const TableCellShipperNotesWrapper = styled(Table.Cell)`
  width: 45%;
`

export const TableCellLastRateWrapper = styled(Table.Cell)`
  width: 10%;
`

export const TableCellNotesWrapper = styled(Table.Cell)`
  width: 30%;
`

export const RatesTextField = styled(TextField)`
  max-width: 110px;
`

export const NotesTextField = styled(TextField)`
  width: 100%;
`
